import API from '../dataApi';

// -- Accounting: Ledger Accounts -----------------------------------------------
// All active accounts including system (for data-entry dropdowns)
export const getAllLedgerAccounts = (derasarId) => API.get('/ledger-accounts/all', { params: { derasarId } });
// Active + inactive — for ledger/report views that need full history
export const getAllLedgerAccountsWithInactive = (derasarId) =>
  API.get('/ledger-accounts/all', { params: { derasarId, includeInactive: 'true' } });
// Accounts under a specific sub-group (for chart of accounts right panel)
export const getLedgerAccountsBySubGroup = (derasarId, subGroupId) =>
  API.get('/ledger-accounts/by-subgroup', { params: { derasarId, subGroupId } });
// User-created accounts only (for ledger management table)
export const getAccountingLedgerAccounts = (params) => API.get('/ledger-accounts', { params });
export const getInactiveLedgerAccounts = (derasarId) => API.get('/ledger-accounts/inactive', { params: { derasarId } });
export const createAccountingLedgerAccount = (data) => API.post('/ledger-accounts', data);
export const updateAccountingLedgerAccount = (id, data) => API.put(`/ledger-accounts/${id}`, data);
export const reactivateLedgerAccount = (id) => API.put(`/ledger-accounts/${id}/reactivate`);
export const deleteAccountingLedgerAccount = (id) => API.delete(`/ledger-accounts/${id}`);
export const permanentDeleteLedgerAccount = (id) => API.delete(`/ledger-accounts/${id}/permanent`);
